import { API_URL } from '../../../app-config/constants';
import type {
    AnytimeFeedbackTemplateDto,
    CycleFeedbackTemplateDto,
    FeedbackTemplateDto,
} from '../../../types/FeedbackTemplateDto';
import { get, post, put, remove } from '../request';

const BASE = `${API_URL}/feedback/template`;

const createApi = <T extends FeedbackTemplateDto>(type: T['type']) => {
    const updateOnCreate = (args: [], x: T, xs: T[]) => [x, ...xs];

    getAll.operation = 'READ';
    getAll.updateOnCreate = updateOnCreate;
    function getAll(): Promise<T[]> {
        return get(toUrl(type));
    }

    getAllActive.operation = 'READ';
    function getAllActive(): Promise<T[]> {
        return get(toUrl(type, 'active'));
    }

    create.operation = 'CREATE';
    create.invalidates = ['getAllActive'];
    function create(template: T): Promise<T> {
        return post(toUrl(type), { postData: template });
    }

    edit.operation = 'UPDATE';
    edit.invalidates = ['getAllActive'];
    function edit(template: T): Promise<T> {
        return put(toUrl(template.id), { postData: template });
    }

    deleteFn.operation = 'DELETE';
    function deleteFn(id: string): Promise<void> {
        return remove(toUrl(id));
    }

    invalidateActive.invalidates = ['getAllActive'];
    function invalidateActive() {
        return Promise.resolve();
    }

    return {
        getAll,
        getAllActive,
        create,
        edit,
        deleteFn,
        invalidateActive,
    };
};

export const feedbackTemplateAnytime = createApi<AnytimeFeedbackTemplateDto>('ANYTIME');
export const feedbackTemplateCycle = createApi<CycleFeedbackTemplateDto>('CYCLE');

function toUrl(...path: string[]) {
    return [BASE, ...path].join('/');
}
